import { CLIENTS } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

export const Clients = () => (
  <section
    id="clients"
    data-testid="clients-section"
    className="relative bg-ivory py-14 md:py-16"
  >
    <div className="mx-auto max-w-shell px-6 md:px-10">
      <Reveal>
        <div className="label-xs text-slate">Trusted by</div>
      </Reveal>

      <Reveal delay={0.08}>
        <ul className="mt-8 flex flex-wrap items-center justify-between gap-x-10 gap-y-7">
          {CLIENTS.map((name) => (
            <li
              key={name}
              data-testid={`client-${name.toLowerCase().replace(/[^a-z]/g, "")}`}
              className="font-display text-lg md:text-[1.35rem] leading-none tracking-[0.02em] text-obsidian/75 hover:text-obsidian transition-colors duration-500 whitespace-nowrap"
            >
              {name}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export default Clients;
